import { css, SerializedStyles } from "@emotion/react"

import * as Monoid from "fp-ts/es6/Monoid"

export const serializedStyles: Monoid.Monoid<SerializedStyles> = {
  concat: css,
  empty: css([""]),
}
